import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { AreaName } from 'domain/constants';
import { OperationType } from 'library/models/enums/OperationType';
import { createArea } from 'library/utils/helpers/AreaHelper';

import LazyRouteElement from './common/LazyRoute';

const TypographyPage = lazy(
	() => import('pages/developers/DevelopersTypographyPage')
);
const ComponentsPage = lazy(
	() => import('pages/developers/DevelopersComponentsPage')
);
const DeploymentAlertPage = lazy(
	() => import('pages/developers/DevelopersDeploymentAlertPage')
);
const ManageTrainingsPage = lazy(
	() => import('pages/developers/DevelopersManageTrainingsPage')
);
const ManageReleaseNotesPage = lazy(
	() => import('pages/developers/DevelopersManageReleaseNotesPage')
);
const ManageRolesPage = lazy(
	() => import('pages/developers/DevelopersManageRolesPage')
);
const PcPublicWebpages = lazy(
	() => import('pages/developers/PcPublicWebpages')
);
const SupportToolsPage = lazy(
	() => import('pages/developers/DevelopersSupportToolsPage')
);
const ChatbotPage = lazy(
	() => import('pages/developers/DevelopersChatbotPage')
);

export const getDevelopersRoutes = (): React.JSX.Element[] => {
	return [
		<Route
			key={'typography'}
			path={'typography'}
			element={
				<LazyRouteElement
					area={createArea(
						AreaName.DevelopersTestPage,
						OperationType.Read
					)}
					Component={TypographyPage}
					path={'typography'}
				/>
			}
		/>,
		<Route
			key={'components'}
			path={'components'}
			element={
				<LazyRouteElement
					area={createArea(
						AreaName.DevelopersTestPage,
						OperationType.Read
					)}
					Component={ComponentsPage}
					path={'components'}
				/>
			}
		/>,
		<Route
			key={'managedeploymentalert'}
			path={'managedeploymentalert'}
			element={
				<LazyRouteElement
					area={createArea(
						AreaName.ManageDeploymentAlert,
						OperationType.Read
					)}
					Component={DeploymentAlertPage}
					path={'managedeploymentalert'}
				/>
			}
		/>,
		<Route
			key={'managetrainings'}
			path={'managetrainings'}
			element={
				<LazyRouteElement
					area={createArea(
						AreaName.ManageTrainings,
						OperationType.Read
					)}
					Component={ManageTrainingsPage}
					path={'managetrainings'}
				/>
			}
		/>,
		<Route
			key={'managereleasenotes'}
			path={'managereleasenotes'}
			element={
				<LazyRouteElement
					area={createArea(
						AreaName.ManageReleaseNotes,
						OperationType.Write
					)}
					Component={ManageReleaseNotesPage}
					path={'managereleasenotes'}
				/>
			}
		/>,
		<Route
			key={'manageroles'}
			path={'manageroles'}
			element={
				<LazyRouteElement
					area={createArea(
						AreaName.DevelopersTestPage,
						OperationType.Write
					)}
					Component={ManageRolesPage}
					path={'manageroles'}
				/>
			}
		/>,
		<Route
			key={'PcPublicWebpages'}
			path={'PcPublicWebpages'}
			element={
				<LazyRouteElement
					area={createArea(
						AreaName.DevelopersTestPage,
						OperationType.Read
					)}
					Component={PcPublicWebpages}
					path={'PcPublicWebpages'}
				/>
			}
		/>,
		<Route
			key={'SupportToolsPage'}
			path={'SupportToolsPage'}
			element={
				<LazyRouteElement
					area={createArea(AreaName.SupportTool, OperationType.Read)}
					Component={SupportToolsPage}
					path={'SupportToolsPage'}
				/>
			}
		/>,
		<Route
			key={'ChatbotPage'}
			path={'ChatbotPage'}
			element={
				<LazyRouteElement
					area={createArea(AreaName.SupportTool, OperationType.Read)}
					Component={ChatbotPage}
					path={'ChatbotPage'}
				/>
			}
		/>,
	];
};
